module.exports = __webpack_public_path__ + "img/xhsjwl.6c5cb2a6.png";